import { Formik } from "formik";
import ErrorMessage from "../../../form/ErrorMessage";
import { step1BootCampSchema } from "../../../../utils/schema";
import {
  getBootCampFormData,
  updateBootCampFormData,
} from "../../../../utils/pip";

const CreateBootCampStep1 = ({ onClose, onHanldeSubmit, isEdit }) => {
  const savedData = getBootCampFormData().step1;

  const handleStep1 = (values) => {
    updateBootCampFormData("step1", values);
    onHanldeSubmit();
  };

  return (
    <div
      className="modal d-block modal-lg ct_congratulation_modal_fade"
      tabIndex="-1"
    >
      <div className="modal-dialog modal-dialog-centered ct_modal-dialog">
        <div className="modal-content">
          <div className="modal-header border-0">
            <button
              type="button"
              className="btn-close ct_circle_close"
              onClick={onClose}
            ></button>
          </div>
          <div className="modal-body px-0">
            <h4 className="ct_fw_600 mb-1 ct_fs_20 ct_darksky_blue_text px-4 ">
              {isEdit ? "Update" : "Create"} your bootcamp step 1
            </h4>
            <p className="mb-0 ct_grey_text px-4">
              {isEdit ? "Update" : "Create"} and schedule {isEdit ? "" : "new"} bootcamp seamlessly.
            </p>
            <Formik
              initialValues={savedData}
              enableReinitialize
              validationSchema={step1BootCampSchema}
              onSubmit={(values, actions) => {
                handleStep1(values);
              }}
            >
              {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                setFieldValue,
                setFieldError,
                setTouched,
              }) => (
                <form
                  action={handleSubmit}
                  className="mt-4 ct_modal_scroll ct_custom_scroll px-4 "
                >
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group mb-4">
                        <label className="d-block mb-2">Bootcamp Heading</label>
                        <textarea
                           rows="2"
                          className="form-control ct_input h-auto"
                          placeholder="You’ll Get the Most Out of This If ?"
                          id="header_title"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          value={values?.header_title}
                        ></textarea>
                        <ErrorMessage
                          errors={errors}
                          touched={touched}
                          fieldName={"header_title"}
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group mb-4">
                        <label className="d-block mb-2">
                          Bootcamp Sub Heading
                        </label>
                         <textarea
                           rows="2"
                          className="form-control ct_input h-auto"
                          placeholder="You’ll Get the Most Out of This If ?"
                          id="header_sub_title"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          value={values?.header_sub_title}
                       ></textarea>
                        <ErrorMessage
                          errors={errors}
                          touched={touched}
                          fieldName={"header_sub_title"}
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group mb-4">
                        <label className="d-block mb-2">
                          Bootcamp Start Date
                        </label>
                        <input
                          type="date"
                          className="form-control ct_input"
                          id="start_date"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          value={values?.start_date}
                          min={new Date().toISOString().split("T")[0]}
                        />
                        <ErrorMessage
                          errors={errors}
                          touched={touched}
                          fieldName={"start_date"}
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group mb-4">
                        <label className="d-block mb-2">
                          Bootcamp End Date
                        </label>
                        <input
                          type="date"
                          className="form-control ct_input"
                          id="end_date"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          value={values?.end_date}
                          min={new Date().toISOString().split("T")[0]}
                        />
                        <ErrorMessage
                          errors={errors}
                          touched={touched}
                          fieldName={"end_date"}
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group mb-4">
                        <label className="d-block mb-2">
                          Bootcamp Location
                        </label>
                       <textarea
                           rows="2"
                          className="form-control ct_input h-auto"
                          id="location"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          value={values?.location}
                          placeholder="Location"
                        />
                        <ErrorMessage
                          errors={errors}
                          touched={touched}
                          fieldName={"location"}
                        />
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="form-group mb-4">
                        <label className="d-block mb-2">
                          Bootcamp Description
                        </label>
                        <textarea
                           rows="2"
                          className="form-control ct_input h-auto"
                          placeholder=" a summary of the event purpose in 2000 characters "
                          id="header_description"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          value={values?.header_description}
                        />
                        <ErrorMessage
                          errors={errors}
                          touched={touched}
                          fieldName={"header_description"}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="d-flex align-items-center gap-3 justify-content-center pt-4">
                    <button
                      className="ct_sky_blue_btn ct_yellow_btn px-5 py-2"
                      type="button"
                      onClick={handleSubmit}
                    >
                      Continue
                    </button>
                  </div>
                </form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateBootCampStep1;
